'use client';

import { fetcher } from '@insta-club/api';
import { VideoPlayIcon } from '@insta-club/components';
import { useBoolean } from '@insta-club/hooks';
import { Guides } from '@insta-club/models';
import { Button, GuideDialog } from '@insta-club/ui';
import Image from 'next/image';
import Link from 'next/link';
import useSWR from 'swr';

function WelcomeVideo() {
    const dialog = useBoolean();
    const { data, isLoading } = useSWR<{ data: Guides }>(`/guides/welcome`, (url: string) =>
        fetcher(url, 'web', 'GET')
    );

    return (
        <>
            {isLoading ? (
                <div className='shadow-main animate-pulse rounded-2xl bg-white p-6'>
                    <div className='relative mb-4 overflow-hidden rounded-2xl bg-gray-200'>
                        <div className='aspect-[307/382] w-full bg-gray-200' />
                    </div>

                    <div className='mb-2 h-5 w-1/3 rounded bg-gray-200' />

                    <div className='mb-3.5 space-y-2'>
                        <div className='h-4 w-full rounded bg-gray-200' />
                        <div className='h-4 w-5/6 rounded bg-gray-200' />
                        <div className='h-4 w-4/5 rounded bg-gray-200' />
                    </div>

                    <div className='space-y-2.5'>
                        <div className='flex space-x-2.5'>
                            <div className='h-9 w-1/2 rounded-md bg-gray-200' />
                            <div className='h-9 w-1/2 rounded-md bg-gray-200' />
                        </div>
                        <div className='h-9 w-full rounded-md bg-gray-200' />
                    </div>
                </div>
            ) : (
                <>
                    <div className='shadow-main rounded-2xl bg-white p-6 leading-6'>
                        {data && (
                            <div className='relative mb-4 cursor-pointer overflow-hidden rounded-2xl'>
                                <div className='relative aspect-[307/382] w-full'>
                                    <Image
                                        fill
                                        className='object-cover'
                                        src={data?.data?.thumbnail ?? '/img-not-found-placeholder.jpg'}
                                        alt='educational-post'
                                        sizes='(max-width: 640px) 100vw, 100vw'
                                    />
                                </div>
                                <div
                                    className='absolute inset-0 z-[1] flex flex-col items-start justify-between'
                                    style={{
                                        background:
                                            'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 0.01%, rgba(0, 0, 0, 0.656458) 60.92%, rgba(0, 0, 0, 0.8) 95.84%)'
                                    }}
                                >
                                    <div
                                        onClick={() => {
                                            dialog.onTrue();
                                        }}
                                        className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform'
                                    >
                                        <VideoPlayIcon />
                                    </div>
                                </div>
                            </div>
                        )}

                        <h2 className='mb-1.5 text-base font-bold text-gray-900'>سلام دوست من ❤️</h2>
                        <p className='mb-3.5 text-base leading-6 font-medium text-gray-700'>
                            برای استفاده درست و بهترین بازخورد پیشنهاد میکنیم تور آموزشی اینستاکلاب رو از دست ندید
                            همینطور تیم پشتیبانی ما آماده پاسخگویی به سوالات شماست , خیلی خوشحالیم که شما در خانواده
                            بزرگ اینستاکلاب عضو شدید
                        </p>
                        <div className='space-y-2.5'>
                            <div className='flex space-x-2.5'>
                                <div className='w-1/2'>
                                    <Link href={'/tour'}>
                                        <Button fullWidth size='sm' variant='outline'>
                                            تور آموزشی
                                        </Button>
                                    </Link>
                                </div>
                                <div className='w-1/2'>
                                    <Link href={'/support'}>
                                        <Button fullWidth size='sm' variant='outline'>
                                            پشتیبانی کاربران
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                            <Link href={'/subscription'}>
                                <Button fullWidth size='sm'>
                                    خرید و فعال‌سازی اشتراک ویژه
                                </Button>
                            </Link>
                        </div>
                    </div>
                    <GuideDialog open={dialog.value} onClose={dialog.onFalse} guide={data?.data} />
                </>
            )}
        </>
    );
}

export default WelcomeVideo;

